module.exports = require('./helpers/bundle-url').getBundleURL('1gihZ') + "logo.7718c6df.svg";